import { List, SvgIconProps } from '@mui/material';
import { NavCollapse } from '@procureai/ui-mui';
import { ComponentType, useMemo } from 'react';

import { AstroSmartLinkDomain } from '@/generated/gql/graphql';
import { RouteId } from '~/routes';

import { useSmartLinks } from './hooks/useSmartLinks';
import { SmartLinksNavListItem } from './SmartLinksNavListItem';

export interface SmartLinksNavListProps {
  children?: React.ReactNode;
  domain: AstroSmartLinkDomain;
  Icon?: ComponentType<SvgIconProps>;
  label: React.ReactNode;
}

export const SmartLinksNavList = ({ children, domain, Icon, label }: SmartLinksNavListProps) => {
  const { smartLinks } = useSmartLinks({ domain });

  const filtersMapped = useMemo(() => {
    return smartLinks
      .filter((i) => !i.hidden)
      .map((link) => ({
        link,
        to: {
          pathname: RouteId.smartLinksDetail(link.id),
        },
      }));
  }, [smartLinks]);

  return (
    <NavCollapse in={true} icon={Icon ? <Icon /> : null} label={label} sx={{ marginBottom: 4 }}>
      <List sx={{ paddingBottom: 0 }}>
        {filtersMapped.map(({ link, to }) => (
          <SmartLinksNavListItem key={link.id} title={link.title} to={to} />
        ))}
      </List>
      {children}
    </NavCollapse>
  );
};
